import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

/** Picks which hybrid a single-hybrid view shows. Renders nothing for fewer than two. */
function HybridRadioGroup({
    hybrids,
    selectedId,
    onSelect,
}: {
    hybrids: { id: number; catalogName: string }[];
    selectedId: number;
    onSelect: (id: number) => void;
}) {
    if (hybrids.length < 2) return null;
    return (
        <RadioGroup row value={String(selectedId)} onChange={(event) => onSelect(Number(event.target.value))}>
            {hybrids.map((hybrid) => (
                <FormControlLabel
                    key={hybrid.id}
                    value={String(hybrid.id)}
                    control={<Radio color='secondary' />}
                    label={
                        <Typography variant='body2' color='primary' fontWeight={hybrid.id === selectedId ? 700 : 400}>
                            {hybrid.catalogName}
                        </Typography>
                    }
                />
            ))}
        </RadioGroup>
    );
}

export default HybridRadioGroup;
